import {
  APPLY_RETURN_GOODS,
  REFUND_CANCEL,
  REFUND_CHECK_PASS,
  REFUND_REJECT,
  REFUND_SELLER_RECEIVE,
  REFUND_SELLER_SEND,
  REFUND_SUCCESS,
  REFUND_USER_SEND,
  REFUND_WAIT_CHECK,
} from 'constants/refund';

export function getRefundStatusTitle(status, type) {
  const showTitle = (type === APPLY_RETURN_GOODS || !type) ? '退款' : '换货';
  switch (status) {
    case REFUND_REJECT:
      return '售后被拒';
    case REFUND_CANCEL:
      return `取消${showTitle}`;
    case REFUND_WAIT_CHECK:
      return '待审核';
    case REFUND_CHECK_PASS:
      return '审核通过';
    case REFUND_USER_SEND:
      return '用户已发货';
    case REFUND_SELLER_RECEIVE:
      return '卖家已收货';
    case REFUND_SELLER_SEND:
      return '卖家已发货';
    case REFUND_SUCCESS:
      return `完成${showTitle}`;
    default:
      return '';
  }
}
